import { takeLatest, all } from 'redux-saga/effects';
import { CaravansApi, PartsApi } from '../services/apis/';
import { CaravanTypes } from '../redux/caravansRedux';
import { ConfigTypes } from '../redux/configurationRedux';
import { PartTypes } from '../redux/partsRedux';
import {
    listCaravansSaga,
    getCaravanSaga
} from './caravansSagas';
import { listPartsSaga, resetPartsSaga } from './partsSagas';

const caravansApi = CaravansApi.create();
const partsApi = PartsApi.create();

function* actionWatcher() {
    yield takeLatest(CaravanTypes.GET_CARAVAN_REQUEST, getCaravanSaga, caravansApi);
    yield takeLatest(CaravanTypes.LIST_CARAVANS_REQUEST, listCaravansSaga, caravansApi);

    yield takeLatest(PartTypes.LIST_PARTS_REQUEST, listPartsSaga, partsApi);
    yield takeLatest(ConfigTypes.SET_REFRESHING, resetPartsSaga);
}

const rootSaga = function* root() {
    yield all([
        actionWatcher(),
    ]);
};

export default rootSaga;
